/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Lp quality statistic DTO
 */
export interface LpQualityStatDto {
  liquidityProviderId: number;
  pairId: number;
  /**
   * Present only when the request was filtered by accountId
   */
  accountId?: number;
  minExecTime: number;
  maxExecTime: number;
  canceledCount: number;
  partFilledCount: number;
  filledCount: number;
  avgExecTime: number;
  avgLpSideTime?: number;
  minLpSideTime?: number;
  maxLpSideTime?: number;
  improvementBps: number;
}
